import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { 
	Button, IconButton
} from '@material-ui/core';
import {
	Lock as LockIcon, LockOpen as LockOpenIcon, GetApp as GetAppIcon
} from '@material-ui/icons';
import clsx from 'clsx';

import { 
	getDayText, weekDays 
} from '../calendar';
import { findParentHasAttribute } from '../util/domUtils';
import { SET_CUSTOMER } from '../customer-order';

import { 
	downloadDailyDeliverySpecs,
	findOrderOfDay, getDayOrdersCount, getDeliveryGroupColor, getServiceTimeText
} from "./functions";
import { UPDATE_PICKUPTIME, LOCK_SCHEDULE, UNLOCK_SCHEDULE } from './reducer';
import styles from './OrderCalendar.module.css';
import TimeInput from './TimeInput';

const OrderCalendar = ({ date, orders,
	onClickDownloadOrders, onClickDownloadDeliveris }) => {
	const dispatch = useDispatch();
	const history = useHistory();

	// get dates of week  
	const datesOfWeek = weekDays(date);
	
	// group orders 
	const weekCustomerOrders = orders.filter(customerOrders => {
		return datesOfWeek.some(day => {
			const dayOrders = findOrderOfDay(customerOrders, day);
			return dayOrders.length > 0;
		});
	});

	const handleClickCustomer = useCallback(evt => {
		// set customerId of customer-order state
		const targetEl = findParentHasAttribute(evt.currentTarget, 'data-customerid');
    if (!targetEl) {
      console.error('can\'t find a button element to delete.');
      return ;
    }
		const customerId = parseInt(targetEl.getAttribute('data-customerid'));
		const customerName = targetEl.getAttribute('data-customername');
		dispatch({
			type: SET_CUSTOMER,
			payload: {
				customer: {
					id: customerId,
					name: customerName
				}
			}
		});

		// route to customer-order 
		setTimeout(() => {
			history.push('/customer/schedules');
		});

	});

	const handleClickLock = useCallback(evt => {
		const targetEl = findParentHasAttribute(evt.currentTarget, 'data-customerid');
    if (!targetEl) {
      console.error('can\'t find a button element to delete.');
      return ;
    }
		const customerId = parseInt(targetEl.getAttribute('data-customerid'));
		const serviceTime = targetEl.getAttribute('data-servicetime');
		const date = Date.parse(targetEl.getAttribute('data-date'));
		dispatch({
			type: LOCK_SCHEDULE,
			payload: {
				customerId,
				serviceTime,
				date
			}
		});
	});

	const handleClickUnlock = useCallback(evt => {
		const targetEl = findParentHasAttribute(evt.currentTarget, 'data-customerid');
    if (!targetEl) {
      console.error('can\'t find a button element to delete.');
      return ;
    }
		const customerId = parseInt(targetEl.getAttribute('data-customerid'));
		const serviceTime = targetEl.getAttribute('data-servicetime');
		const date = Date.parse(targetEl.getAttribute('data-date'));
		dispatch({
			type: UNLOCK_SCHEDULE,
			payload: {
				customerId,
				serviceTime,
				date
			}
		});
	});

	const handleChangePickupTime = (customerId, date, serviceTime, 
		menuId, pickupTime) => {
		dispatch({
			type: UPDATE_PICKUPTIME,
			payload: {
				customerId,
				date,
				serviceTime,
				menuId,
				pickupTime
			}
		});
	}

	return (
		<div>
			{/* {weeks.map((week, weekIdx) => (
				<WeekView
					key={'week-' + weekIdx}
					week={week}
					// orders={orders}
					orders={weekCustomerOrders[weekIdx]}
					onClickCustomer={handleClickCustomer}
					onClickLock={handleClickLock}
					onClickUnlock={handleClickUnlock}
					onChangePickupTime={handleChangePickupTime}
				/>
			))} */}
			<WeekView
				key={'week-0'}
				week={datesOfWeek}
				orders={weekCustomerOrders}
				onClickCustomer={handleClickCustomer}
				onClickLock={handleClickLock}
				onClickUnlock={handleClickUnlock}
				onChangePickupTime={handleChangePickupTime}
				onClickDownloadOrders={onClickDownloadOrders}
				onClickDownloadDeliveris={onClickDownloadDeliveris} />
		</div>
	);
}


const WeekView = ({ week, orders, onClickCustomer,
				onClickLock, onClickUnlock, onChangePickupTime,
				onClickDownloadOrders, onClickDownloadDeliveris }) => {

	const handleClickDailyDelivery = (evt) => {
		const day = evt.currentTarget.getAttribute('data-day');
		onClickDownloadDeliveris(week[day]);
	}

	const handleClickDailyOrder = (evt) => {
		const day = evt.currentTarget.getAttribute('data-day');
		onClickDownloadOrders(week[day]);
	}

	return (
		<div className={styles.weekRow}>
			{/* bg */}
			<div className={styles.weekRowBg}>
				<div className={styles.customerColumn}></div>
				{week.map((day, i) => (
					<div
						key={i}
						className={styles.orderColumn}
					>
					</div>
				))}
			</div>
			{/* header */}
			<div className={styles.weekHeaderRow}>
				<div className={styles.customerColumn}></div>
				{week.map((day, i) => (
					<div
						key={i}
						className={styles.orderColumn}>
							<div className={styles.weekHeader}>
								{getDayText(day, false)}
							</div>
							<div className={styles.weekHeader}>
								{day.getDate()}
							</div>
					</div>
				))}
			</div>
			{/* orders */}
			{orders.map((customerOrders, i) => 
				<CustomerOrders
					key={i}
					customerOrders={customerOrders}
					week={week} 
					onClickCustomer={onClickCustomer}
					onClickLock={onClickLock}
					onClickUnlock={onClickUnlock}
					onChangePickupTime={onChangePickupTime}
				/>
			)}
			{/* footer */}
			<div className={styles.weekFooterRow}>
				<div className={styles.customerColumn}></div>
				{week.map((day, i) => (
					<div
						key={i}
						className={styles.orderColumn}
					>
						<div className={styles.weekFooter}>
							<div>
								<Button 
									size="small"
									variant="outlined"
									startIcon={<GetAppIcon />}
									data-day={i}
									onClick={handleClickDailyDelivery}
								>
									배송명찰
								</Button>
								<Button 
									size="small"
									variant="outlined"
									startIcon={<GetAppIcon />}
									data-day={i}
									onClick={handleClickDailyOrder}
								>
									조리주문
								</Button>
							</div>
							<div className={styles.dayOrderCount}>{'총계: ' + getDayOrdersCount(orders, day)}</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
}

const CustomerOrders = ({ customerOrders, week, 
				onClickCustomer, onClickLock, onClickUnlock, onChangePickupTime }) => {
	
	// check locked, published
	let firstOrder;
	week.some(day => {
		const dayOrders = findOrderOfDay(customerOrders, day);
		if (dayOrders.length > 0) {
			firstOrder = dayOrders[0];
			return true;
		}
		return false;
	});

	const isLocked = firstOrder?.lock ?? false;
	// const isPublished = firstOrder?.published ?? false;

	const handleChangePickupTime = (date, menuId, pickupTime) => {
		onChangePickupTime(customerOrders.customerId, date,
			customerOrders.serviceTime, menuId, pickupTime);
	}

	return (
		<div 
			className={styles.customerOrderRow} 
			style={{ 
				backgroundColor: getDeliveryGroupColor(customerOrders.deliveryGroup)
			}}
		>
			{/* customer info */}
			<div className={styles.customerColumn}>
				{/* isLocked ? (
					<IconButton
						size="small"
						aria-label="unlock schedule"
						onClick={onClickUnlock}
						data-customerid={customerOrders.customerId}
						data-servicetime={customerOrders.serviceTime}
						data-date={week[0].toISOString()}
						color="secondary"
						// disabled={isPublished}
					>
						<LockIcon fontSize="small" />
					</IconButton>
				): (
					<IconButton
						size="small"
						aria-label="lock schedule"
						onClick={onClickLock}
						data-customerid={customerOrders.customerId}
						data-servicetime={customerOrders.serviceTime}
						data-date={week[0].toISOString()}
						// disabled={isPublished}
					>
						<LockOpenIcon fontSize="small" />
					</IconButton>) */}
				<Button 
					data-customerid={customerOrders.customerId}
					data-customername={customerOrders.customerName}
					onClick={onClickCustomer}
				>
					{/* {`${customerOrders.customerName}(${getServiceTimeText(customerOrders.serviceTime)})`} */}
					{`${customerOrders.customerName ?? '이름없음'}`}
				</Button>
			</div>
			{/* orders */}
			{week.map((day, i) => {
				// find the order 
				const dayOrders = findOrderOfDay(customerOrders, day);
				return (
					<div
						key={i}
						className={styles.orderColumn}>
							{dayOrders.length > 0 ? 
							dayOrders.map(order => order.showTextOnly ? 
								<div 
									key={order.id}
									className={styles.showTextOnly} >
									{order.menuName}
								</div> 
								:
								<OrderItem 
									key={order.id}
									order={order} 
									onChangePickupTime={handleChangePickupTime} />
							): 
							<div className={styles.noMenu}>
								없음
							</div>}
					</div>
				);
			})}
		</div>
	);
}

const OrderItem = ({ order, onChangePickupTime }) => {
	const { 
		published, date, supplierName, menuId, menuName, pickupTime, 
		orderQty, estimateQty, manualCheckout, menuType
	} = order;

	const needCaution = !manualCheckout && 
		orderQty !== 0 && orderQty !== estimateQty;

	const handleChange = (newTime) => {
		onChangePickupTime(date, menuId, newTime);
	}

	return (
		<div className={styles.order}>
			<div className={styles.menu}>
				<div className={clsx(styles.supplier,
          {[styles.mfc]: menuType === '3'}
        )}>
          {(menuType === '3' ? 'MFC-' : '') + supplierName}
        </div>
				<div className={clsx(
          styles.menuTitle, {[styles.notPublished]: !order.published}
        )}>{(menuType === '3' ? '🛍️' : '')  + menuName}</div>
			</div>
			<div className={styles.pickupTime}>
				<TimeInput
					defaultValue={pickupTime ?? '0000'}
					onChange={handleChange}
				/>
			</div>
			<div className={clsx(styles.estimateQty, 
				manualCheckout && styles.manualCheckout, 
				needCaution && styles.needCaution)}>
				&nbsp;{estimateQty}&nbsp;
			</div>
			<div className={styles.orderQty}>
				{orderQty}
			</div>
		</div>
	);
}

export default OrderCalendar